import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Toursnavbar from '../components/Toursnavbar';
import Skeleton from 'react-loading-skeleton';
import '../styles/TourDetails.css';


import TourBanner from '../components/TourBanner';
import NeedHelp from '../components/NeedHelp';
import CouponOffer from '../components/CouponOffer';
import PrivacyTermsTab from '../components/PrivacyTermsTab';
import InclusionExclusion from '../components/InclusionExclusion';
import SearchBar from '../components/SearchBar';
import TravelBookingComponent from '../components/TravelBooking';
import GroupDiscountBanner from '../components/GroupDiscount';
import Overview from '../components/Overview.jsx';
import DayWisePlan from '../components/DayWisePlan.jsx';
import Description from '../components/Description.jsx';
import Itinerary from '../components/Itinerary.jsx';
import whatsapp from '../assets/whatsapp icon (1).svg';
import TravelPageNav from '../components/TravelPageNav.jsx';
import PageIntro from '../components/PageIntro';
import Footer from '../components/Footer.jsx';

import BASE_URL from '../config.jsx';

const mockTours = {
  1: {
    ID: 1,
    CreatedAt: "2024-12-28T19:12:51.869783Z",
    UpdatedAt: "2024-12-28T19:12:51.869783Z",
    DeletedAt: null,
    Name: "Romantic Paris Getaway",
    Description: "A 7-day romantic tour exploring the highlights of Paris.",
    NumberOfDays: 7,
    NumberOfNights: 6,
    BestMonthsToVisit: "April, May, September, October",
    Type: "Couple",
    TourCategory: "Luxury",
    Inclusions: "Accommodation, Meals, Sightseeing, Transportation",
    Exclusions: "Personal expenses, Tips, Visa fees",
    TotalKMSCovered: 500,
    EstimatedPopularity: 85,
    InsuranceIncluded: true,
    VisaProvision: true,
    ForexProvision: true,
    TourDetails: null,
    TourImages: null,
    TourTags: null,
    TourMajorAttractions: null,
    TourPlaces: null,
    TourThemes: null
  },
  2: {
    ID: 2,
    CreatedAt: "2024-12-28T19:12:51.869783Z",
    UpdatedAt: "2024-12-28T19:12:51.869783Z",
    DeletedAt: null,
    Name: "Adventure in the Swiss Alps",
    Description: "A 10-day thrilling adventure in the heart of the Swiss Alps.",
    NumberOfDays: 10,
    NumberOfNights: 9,
    BestMonthsToVisit: "June, July, August",
    Type: "Adventure",
    TourCategory: "Outdoor",
    Inclusions: "Guided Trekking, Accommodation, Transportation",
    Exclusions: "Personal expenses, Travel Insurance",
    TotalKMSCovered: 800,
    EstimatedPopularity: 90,
    InsuranceIncluded: false,
    VisaProvision: true,
    ForexProvision: false,
    TourDetails: null,
    TourImages: null,
    TourTags: null,
    TourMajorAttractions: null,
    TourPlaces: null,
    TourThemes: null
  }
};

const TourDetails = () => {
  const { id } = useParams();
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  // SearchBar state
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [departureFrom, setDepartureFrom] = useState('New Delhi');
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [totalGuests, setTotalGuests] = useState(adults + children);


  const fetchTourDetails = async (tourID) => {
    try {
      const response = await fetch(`${BASE_URL}/api/tour/${tourID}`);
      if (!response.ok) throw new Error("Failed to fetch tour details");

      const result = await response.json();
      return result?.data || null;
    } catch (error) {
      console.warn(`API failed. Using mock data for tour ID ${tourID}.`);
      return mockTours[tourID] || null;
    }
  };

  useEffect(() => {
    const loadTour = async () => {
      setLoading(true);
      const tourData = await fetchTourDetails(id);
      setTour(tourData);
      setLoading(false);
      setIsLoading(false);
    };

    loadTour();
  }, [id]);

  if (loading) return <p></p>;
  if (!tour) return <p>Tour not found.</p>;

  return (
    <div>
      <header><Toursnavbar /></header>
      <div className='panel'>
        <div className='main-upper-panel'>
          {isLoading ? (
            <>
              <Skeleton height={50} width={300} />
              <Skeleton height={200} />
              <Skeleton height={400} />
              <Skeleton height={300} />
              <Skeleton height={50} />
            </>
          ) : (
            <>
              <SearchBar
                startDate={startDate}
                setStartDate={setStartDate}
                departureFrom={departureFrom}
                setDepartureFrom={setDepartureFrom}
                adults={adults}
                setAdults={setAdults}
                children={children}
                setChildren={setChildren}
                rooms={rooms}
                setRooms={setRooms}
                totalGuests={totalGuests}
                setTotalGuests={setTotalGuests}
                tourId={id}
              />

              <PageIntro tour={tour} tourId={id} />
              <TourBanner tour={tour} tourId={id} />
              <Description tour={tour} tourId={id} />
              <TravelPageNav tour={tour} tourId={id} />

            </>
          )}
        </div>

        <div className='main-middle-panel'>
          <div className='main-left-panel'>
            {isLoading ? (
              <Skeleton height={500} />
            ) : (
              <>
                <div id="overview"><Overview tour={tour} tourId={id} /></div>
                <div id="itinerary"><Itinerary tour={tour} tourId={id} /></div>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                  <button
                    style={{
                      padding: '10px 20px',
                      borderRadius: '30px',
                      backgroundColor: '#541C9C',
                      color: '#FFFFFF',
                      border: 'none',
                      fontSize: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    Get Itinerary <img src={whatsapp} alt="WhatsApp icon" style={{ width: '20px', height: '20px' }} />
                  </button>
                </div>

                <div id="inclusionExclusion"><InclusionExclusion tour={tour} tourId={id} /></div>
              </>
            )}
          </div>

          <div className='main-right-panel'>
            {isLoading ? (
              <Skeleton height={500} width="100%" />
            ) : (
              <>
                <TravelBookingComponent
                  tour={tour}
                  tourId={id}
                />
                <CouponOffer tour={tour}tourId={id} />
                <NeedHelp tour={tour}tourId={id} />
                <GroupDiscountBanner tour={tour}tourId={id} />
              </>
            )}
          </div>
        </div>

        <div className='main-bottom-panel'>
          {isLoading ? (
            <Skeleton height={300} />
          ) : (
            <>
              <DayWisePlan tour={tour}tourId={id} />
              <PrivacyTermsTab tour={tour} tourId={id} />
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TourDetails;


